import { Component } from 'react'
import { Modal } from 'antd';
interface Props {
    loadingConfirm?: boolean,
    visibleModal?: boolean,
    handleAcceptModal?: any,
    handleCloseModal?: any,
    okText?: string,
    cancelText?: string,
    title?: string,
    btnDisable?: boolean,
    cancelDisable?: boolean,
    content?: any,
    none?: any,
    width?: number | string,
    maskClosable?: boolean,
    closable?: boolean,
    keyboard?: boolean,
}
export class ModalCompnent extends Component<Props> {
    render() {
        const { loadingConfirm, visibleModal, okText, cancelText,
            title, handleAcceptModal, handleCloseModal, content, btnDisable, cancelDisable, none, width,
            maskClosable = true, closable = true, keyboard = true } = this.props;
        return (
            <div>
                <Modal
                    confirmLoading={loadingConfirm}
                    title={title}
                    centered
                    visible={visibleModal}
                    okText={okText}
                    cancelText={cancelText}
                    onOk={handleAcceptModal}
                    onCancel={handleCloseModal}
                    width={width}
                    maskClosable={maskClosable}
                    closable={closable}
                    keyboard={keyboard}
                    okButtonProps={{ disabled: btnDisable, style: { background: '#7cc58f', color: '#fff', border: '1px solid #7cc58f' } }}
                    cancelButtonProps={{ disabled: cancelDisable, style: { display: none ? none : 'inline' } }}

                >
                    {content}

                </Modal>
            </div>
        )
    }
}

export default ModalCompnent
